import React, { useEffect, useMemo, useState   } from "react";
import { Card, Col, Row, Table, Badge, Dropdown } from "react-bootstrap";

import { useLocation, useParams } from "react-router-dom";
import { getUserTasks, updateUserTasks } from "../../services/UserServices/UserService";
import PageTitle from "../layouts/PageTitle";
import { debounce } from "lodash";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import Pagination from "../components/Pagination";
import toast from "react-hot-toast";
export default function TaskPage() {

    const [tasks,setTasks]=useState([]);
   const { id1, id2 } = useParams();   
 
const location = useLocation();
  const historyData = location.state?.history;
 const [sortBy,setSortBy]=useState("")
const [search, setSearch] = useState("");
 const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
   const [totalItems, setTotalItems] = useState(0);
    const getTasks =async()=>{
      try {
                  setLoading(true); 
           const res = await getUserTasks(id1,id2,currentPage,10,search);
            setTotalItems(res?.data?.data?.count);
             
              setTasks(res?.data?.data?.event);
              
      } catch (error) {
          console.error(error?.response?.data?.message);
      }
        finally{
          setLoading(false);
        }
    }
     useEffect(() => {
   
       if(id1){
      getTasks();
   }
     }, [search,sortBy,currentPage]);
 
  useEffect(()=>{setCurrentPage(0)},[search])

 const debouncedSearch = useMemo(() => {
  return debounce((value) => {
    if (value.length >= 3 || value.length === 0) {
      setSearch(value);
    }
  }, 500);
}, []);

useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };
}, [debouncedSearch]);

   const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );
  const totalPages = Math.ceil(totalItems / itemsPerPage);
const handleStatus=async(id)=>{
  try {
     
    await updateUserTasks(id)
getTasks()
    toast.success("status updated successfully")

  } catch (error) {
    console.error(error)
    toast.error(error?.response?.data?.message)
  }
}


  return (
    <div className="qx-page">

 {/* <PageTitle
          motherMenu="User List"
          activeMenu={`${historyData?.user?.hostName ?historyData?.user?.hostName:"User"}  >  ${historyData?.event?.name ?historyData?.event?.name:"Event"} > Task List`}
          pathBack={true}   
        /> */}

        <PageTitle
  breadcrumbs={[
    {
      label: "User List",
      path: "/user-management",
    },
    {
      label: historyData?.user?.hostName || "User",
      path: `/user-details/${id1}`,
      state: {
        history: {
          user: historyData?.user,
        },
      },
    },
    {
      label: historyData?.event?.name || "Event",
      path: `/user_events/${id1}`,
      state: {
        history: {
          user: historyData?.user,
          event: historyData?.event,
        },
      },
    },
    {
      label: "Task List",
    },
  ]}
/>


         
       <div className="pb-2 d-flex justify-content-between gap-2">
        <input
          type="text"
          style={{ borderRadius: "0.5rem", width: "100%" }}
          className="form-control inpp"
          placeholder="Search task"
         
       onChange={(e) => debouncedSearch(e.target.value)}
        />
     
      </div>
   <h3 className="mb-4  head font-fm" style={{ color: "#27272A" , fontSize: "20px"}}>
     {/* {historyData?.user?.hostName} { historyData.user?.hostName?'>':""}{historyData?.event?.name?.name} {">"} Task List */}
      </h3>

      {/* ✅ Wrap Col inside Row */}
      <Row>
        <Col>
          <Card className="qx-table-card">
            <Card.Body>
              <Table responsive bordered className="table-black-border" >
                <thead style={{ color: "#A60000"}}>
                  <tr>
                    <th ><strong>S.NO</strong></th>
                    <th><strong>Task Name</strong></th>
                    <th><strong>Event Name</strong></th>
                    <th><strong>Assigned To</strong></th>
                    <th><strong>Priority</strong></th>
                    <th><strong>Due Date</strong></th>
                    <th><strong>Status</strong></th>
                    <th><strong>Action</strong></th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <TableLoaderRow colSpan={8} />
                  ) : !tasks?.length ? (
                    <TableEmptyRow colSpan={8} message="No tasks found" />
                  ) : (
                    tasks?.map((task, index) => (
      <tr key={index} style={{ color: "#A60000" }}>
        <td>{currentPage*10 + index + 1}</td>
        <td>{task.name}</td>
        <td>{task?.event?.name?.name}</td>
        <td>{task?.assigningToGuest?.name ? task?.assigningToGuest?.name : "Not Assigned"}</td>
        <td>
          <Badge bg={
            task.priority.toLowerCase() === "high"
              ? "danger"
              : task.priority.toLowerCase() === "medium"
              ? "warning"
              : "info"
          }>
            {task.priority.charAt(0).toUpperCase() + task.priority.slice(1)}
          </Badge>
        </td>
        <td>
          {new Date(task?.dueDate).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })}
        </td>
        <td>
          <Badge bg={task.status === "upcoming" ? "secondary" : "success"}>
            {task.status.charAt(0).toUpperCase() + task.status.slice(1)}
          </Badge>
        </td>

 <td>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="qx-action-toggle"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
    

                 {task.status === "upcoming" ?    <Dropdown.Item  
                 onClick={()=>handleStatus(task?._id)}
                        >
                         Mark as Completed
                        </Dropdown.Item>:   <Dropdown.Item  
                          onClick={()=>handleStatus(task?._id)}
                        >
                         Mark as Upcoming
                        </Dropdown.Item>}
                    </Dropdown.Menu>
                  </Dropdown>  

                </td>
      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              {!loading && tasks?.length > 0 && (
                <Pagination
                  pageCount={totalPages}
                  pageValue={currentPage}
                  setPage={setCurrentPage}
                  total={totalItems}
                  pageSize={itemsPerPage}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>





    </div>
  );
}








 